export default {
  resolveItems(currentItems, searchResults, limit) {
    let firstBatch = []
    let nextBatch = []
    let resolvedResults = []
    if (!currentItems) {
      if (searchResults.length > limit) {
        /*
        set the end selection (of the fisrtBatch slice) to the
        length of search results but minus 1 since we retrieved 1
        extra result in order to determine if there are more results
        */
        firstBatch = searchResults.slice(0, searchResults.length - 1)
        nextBatch = searchResults.slice(searchResults.length - 1)
        resolvedResults.push(firstBatch, nextBatch)
      } else {
        firstBatch = searchResults.slice(0, searchResults.length)
        resolvedResults.push(firstBatch)
      }
    } else {
      resolvedResults = JSON.parse(JSON.stringify(currentItems))
      if (searchResults.length < limit) {
        for (let item of searchResults) {
          if (resolvedResults.length) {
            resolvedResults[resolvedResults.length - 1].push(item)
          } else {
            resolvedResults.push(item)
          }
        }
      } else {
        for (let i = 0; i < searchResults.length; i++) {
          if (resolvedResults[resolvedResults.length - 1].length < limit) {
            resolvedResults[resolvedResults.length - 1].push(searchResults[i])
          } else {
            let nextBatch = []
            nextBatch.push(searchResults[searchResults.length - 1])
            resolvedResults.push(nextBatch)
          }
        }
      }
    }
    return resolvedResults
  }
}
